import "./Inventories.scss";

export default function Inventories() {
  return (
    <section className="sales-layout__page inventories">
      <h1>Inventuren</h1>
      <p>Hier werden zukünftig die Inventuren angezeigt!</p>
    </section>
  );
}
